<div class="flex flex-col w-full h-full">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'command.newCondition' | transloco }}</div>
        <button mat-icon-button matDialogClose>
            <mat-icon class="text-current" svgIcon="mat_outline:close"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <form [formGroup]="formGroup" class="flex flex-col flex-auto p-6 sm:p-8" fuseScrollbar>

        <!-- Fields -->
        <mat-form-field>
            <mat-label>{{ 'command.fields' | transloco }}</mat-label>
            <mat-select formControlName="field">
                @for (field of fields; track field.name) {
                    <mat-option [value]="field.name">
                        {{ field.name }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (field) {
            <mat-form-field animate.enter="slide-in-bottom">
                <mat-label>{{ 'command.condition' | transloco }}</mat-label>
                <mat-select formControlName="operator">
                    @for (operator of operators; track operator.code) {
                        <mat-option [value]="operator.code">
                            {{ operator.value | localize }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }

        @if (operator) {
            <div class="flex flex-col flex-auto" animate.enter="slide-in-bottom">
                @if (operator === 'EQUALS' || operator === 'NOT_EQUALS') {
                    @if (currentFieldIsText() || currentFieldIsNumber()) {
                        <mat-form-field>
                            <mat-label>{{ 'command.value' | transloco }}</mat-label>
                            <input matInput [type]="currentFieldIsText() ? 'text' : 'number'" formControlName="operand">
                        </mat-form-field>
                    } @else if (currentFieldIsSelect() || currentFieldIsAutocomplete()) {
                        <!-- Select/Autocomplete types -->
                        <mat-form-field>
                            <mat-label>{{ 'command.value' | transloco }}</mat-label>
                            <mat-select formControlName="operand">
                                <!-- @for (option of currentField.option; track option.code) {
                                    <mat-option [value]="option.code">
                                        {{ option.value | localize }}
                                    </mat-option>
                                } -->
                            </mat-select>
                        </mat-form-field>
                    } @else {
                        <!-- Boolean types -->
                        <div class="flex items-center">
                            @switch (fieldType) {
                                @case (checkboxUri) {
                                    <mat-slide-toggle class="mr-4" color="primary" formControlName="operand">
                                    </mat-slide-toggle>
                                    <div class="cursor-pointer" (click)="operand = !operand">
                                        <div class="leading-6 font-medium">{{ 'command.value' | transloco }}</div>
                                    </div>
                                }
                                @case (tristateUri) {
                                    <mat-radio-group formControlName="operand">
                                        <mat-radio-button class="mr-4" [value]="'TRUE'">
                                            <!-- {{ currentField.trueLabel ? (currentField.trueLabel | localize) : ('yes' | transloco) }} -->
                                        </mat-radio-button>
                                        <mat-radio-button class="mr-4" [value]="'FALSE'">
                                            <!-- {{ currentField.falseLabel ? (currentField.falseLabel | localize) : ('no' | transloco) }} -->
                                        </mat-radio-button>
                                        <mat-radio-button [value]="'UNANSWERED'">
                                            <!-- {{ currentField.emptyLabel ? (currentField.emptyLabel | localize) : ('unanswered' | transloco) }} -->
                                        </mat-radio-button>
                                    </mat-radio-group>
                                }
                                @case (radioUri) {
                                    <mat-radio-group formControlName="operand">
                                        <mat-radio-button class="mr-4" [value]="true">
                                            <!-- {{ currentField.trueLabel ? (currentField.trueLabel | localize) : ('yes' | transloco) }} -->
                                        </mat-radio-button>
                                        <mat-radio-button [value]="false">
                                            <!-- {{ currentField.falseLabel ? (currentField.falseLabel | localize) : ('no' | transloco) }} -->
                                        </mat-radio-button>
                                    </mat-radio-group>
                                }
                            }
                        </div>
                    }
                }

                <!-- Date types -->
                @if (fieldType === datepickerUri) {
                    <mat-form-field>
                        <mat-label>{{ 'command.value' | transloco }}</mat-label>
                        <input matInput formControlName="operand" [matDatepicker]="datepicker" (click)="openDatepickerOnClick(datepicker)"
                            (dateChange)="dateChange($event)" />
                        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                        <mat-datepicker #datepicker></mat-datepicker>
                    </mat-form-field>
                } @else if (fieldType === timepickerUri) {
                    <div class="flex flex-col w-full mb-3">
                        <div class="leading-6 font-medium">{{ 'command.value' | transloco }}</div>
                        <div class="flex flex-row w-full items-center">
                            <timepicker-autofill-component [control]="formGroup.get('operand')" [allowManual]="true" [style]="'HH:mm:ss'">
                            </timepicker-autofill-component>
                        </div>
                    </div>
                }

                @if (currentFieldIsNumber() && (operator === 'GREATERTHAN' || operator === 'LESSTHAN')) {
                    <mat-form-field>
                        <mat-label>{{ 'command.value' | transloco }}</mat-label>
                        <input matInput type="number" formControlName="operand">
                    </mat-form-field>
                }

                @if (operator === 'ONE_OF' || operator === 'NOT_ONE_OF') {
                    <!-- Text types -->
                    @if (!currentFieldIsSelect() && !currentFieldIsAutocomplete() && !currentFieldIsTrigger()) {
                        <mat-form-field>
                            <mat-label>{{ 'command.values' | transloco }}</mat-label>
                            <mat-chip-grid #chipGridText formControlName="operand">
                                @for (op of operand ?? []; track op; let i = $index) {
                                    <mat-chip-row (removed)="removeFromChiplist(i)">
                                        {{ op }}
                                        <mat-icon class="icon-size-5" matChipRemove
                                        svgIcon="heroicons_solid:minus-circle"></mat-icon>
                                    </mat-chip-row>
                                }
                                <input [matChipInputFor]="chipGridText" [formControl]="chiplistControl" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    (matChipInputTokenEnd)="addToChiplist($event)">
                            </mat-chip-grid>
                        </mat-form-field>
                    }

                    <!-- Select/Autocomplete types -->
                    @if (currentFieldIsSelect() || currentFieldIsAutocomplete()) {
                        <mat-form-field>
                            <mat-label>{{ 'command.values' | transloco }}</mat-label>
                            <mat-chip-grid #chipGridSelect>
                                @for (op of operand ?? []; track op; let i = $index) {
                                    <mat-chip-row (removed)="removeFromChiplist(i)">
                                        {{ getChipCaption(op) }}
                                        <mat-icon class="icon-size-5" matChipRemove
                                        svgIcon="heroicons_solid:minus-circle"></mat-icon>
                                    </mat-chip-row>
                                }
                                <input [matChipInputFor]="chipGridSelect" [formControl]="chiplistControl" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                    [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="$event.input.value = ''" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedAutocomplete($event)">
                                    @for (option of filteredOptions; track option.code) {
                                        <mat-option [value]="option.code">
                                            {{ option.value | localize }}
                                        </mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-chip-grid>
                        </mat-form-field>
                    }
                }
            </div>
        }
    </form>

    <!-- Footer -->
    <div class="flex flex-0 items-center justify-end px-6 py-4 space-x-3 bg-gray-50 dark:bg-black dark:bg-opacity-10">
            <button mat-stroked-button matDialogClose>{{ 'cancel' | transloco }}</button>
            <button mat-flat-button color="primary" (click)="save()">{{ 'save' | transloco }}</button>
        </div>
</div>
